import { useField } from 'formik';

import { LabelStyled } from './FormikCheckbox.styled';

type CheckboxPropsT = {
  name: string;
  checked?: boolean;
  disabled?: boolean;
  label?: string | React.ReactNode;
} & React.HTMLAttributes<HTMLInputElement>;

const FormikCheckbox: React.FC<CheckboxPropsT> = ({ name, disabled, checked, label, ...props }) => {
  const [field] = useField(name);

  return (
    <LabelStyled>
      <input type="checkbox" checked={checked} disabled={disabled} {...props} {...field} />
      {label && <span>{label}</span>}
    </LabelStyled>
  );
};

export default FormikCheckbox;
